angular.module('omfm').controller('inboxController', InboxController);

InboxController.$inject = ['$scope', '$rootScope', '$timeout', '$interval', '$sce', 'Labels', 'Accounts', 'Emails', '$location', 'uiSimpleModal'];

function InboxController($scope, $rootScope, $timeout, $interval, $sce, Labels, Accounts, Emails, $location, uiSimpleModal) {
	function clickOnRequiredMessage(keyCode){
		if(!$scope.openedMessage || !$scope.openedMessage.id){
			return;
		}

		let selector;
		let currentElem = jQuery('tr[data-id="' + $scope.openedMessage.id +'"]');
		let currentElemIndex = parseInt(currentElem.data('index'));

		switch (keyCode) {
			case 38: {
				// up
				selector = 'tr[data-index="' + (currentElemIndex - 1) +'"]';
				break;
			}
			case 40:{
				//down
				selector = 'tr[data-index="' + (currentElemIndex + 1) +'"]';
				break;
			}
			default: return;
		}

		$timeout(function(){
			let elemToClick = jQuery(selector);

			if(elemToClick && elemToClick.length > 0){
				elemToClick.click();
			}
		}, 0);
	}

	var request = ''

	function getEmails(selectNext = false){
		$scope.loading = true;

		if(request && typeof request.$cancelRequest === "function") {
			request.$cancelRequest()
		}

		request = Emails.list({filters: $scope.filters, page: $scope.currentPage}, function(paginator){
			$scope.loading = false;
			$scope.messages = paginator.data;
			$scope.selectedMessages = {};
			request = ''

			try {
				$scope.latestId = $scope.messages[0].id;
			} catch (e) {

			}


			$scope.totalItems	= paginator.total;
			$scope.itemsPerPage	= paginator.per_page;
			$scope.currentPage	= paginator.current_page;

			$location.search('filters', angular.toJson($scope.filters));
			$location.search('currentPage', $scope.currentPage);

			if(selectNext){
				if($scope.labelsMode === 'apply') {
					// open message
					$scope.openMessage($scope.messages[$scope.openedMessageIndex + 1], $scope.openedMessageIndex + 1);
				} else {
					// on move message will be shifted and next message will appear on it's place
					$scope.openMessage($scope.messages[$scope.openedMessageIndex], $scope.openedMessageIndex);
				}
			}

		});
	}

	$scope.pageChanged = function(reset = false){
		$scope.filters.label_names = Object.keys($scope.selectedLabels);

		if(reset){
			$scope.currentPage = 1;
		}

		$scope.checkAllActive = false;
		getEmails();
	};

	$scope.refreshAccount = function(inbox = false){
		if(!$scope.filters.account_id || $scope.refreshingAccount) {
			return;
		}

		let account = $scope.accounts.filter(function(i){
			return i.id === $scope.filters.account_id;
		})[0];

		if(!account){
			return;
		}

		$scope.refreshingAccount = account;

		if(inbox) {
			Emails.refreshAccountInbox({account_id: $scope.filters.account_id}, function(){
				$scope.refreshingAccount = false;
				$scope.pageChanged();
			})
		} else {
			Emails.refreshAccountInbox({account_id: $scope.filters.account_id}, function(){
				$scope.refreshingAccount = false;
				$scope.pageChanged();
			})
		}


	};

	$scope.selectMessage = function($index, $event, forceCheck){
		if($event && typeof $event.stopPropagation == 'function'){
			$event.stopPropagation();
		}

		if(typeof forceCheck !='undefined'){
			$scope.messages[$index].checked = forceCheck;
			$scope.selectedMessages[$index] = $scope.messages[$index];
			return;
		}

		$scope.messages[$index].checked = !$scope.messages[$index].checked;

		if($scope.messages[$index].checked){
			$scope.selectedMessages[$index] = $scope.messages[$index];
		} else {
			delete $scope.selectedMessages[$index];
		}
	};

	$scope.checkAll = function () {
		$scope.checkAllActive = !$scope.checkAllActive;
		$scope.selectedMessages = {};

		$scope.messages.forEach(function (e, index) {
			e.checked = $scope.checkAllActive;
			if(e.checked){
				$scope.selectedMessages[index] = e;
			}
		})
	};

	$scope.setOneAndOnlyLabelForFilter = function (label, $event){
		$event.stopPropagation();
		$scope.selectedLabels = {};
		$scope.labelToFilter = label;
		$scope.addLabelToFilter();
	};

	$scope.addLabelToFilter = function(){
		if($scope.selectedLabels[$scope.labelToFilter.id]){
			return;
		}

		if($scope.labelToFilter.id === 'not_labelled_for_report'){
			$scope.selectedLabels = {};
		}

		console.log($scope.labelToFilter);

		$scope.selectedLabels[$scope.labelToFilter.id] = $scope.labelToFilter;
		$scope.labelToFilter = undefined;
		$scope.pageChanged(true);
	};

	$scope.applyLabel = function(label){
		let selectedMessagesIds = Object.values($scope.selectedMessages).map(function(i){
			return i.id;
		});

		if($scope.openedMessage) {
			selectedMessagesIds.push($scope.openedMessage.id);
		}

		Emails.setLabel({
			emailIds: selectedMessagesIds,
			labelId: [label.id],
			moveFromInbox: $scope.labelsMode === 'move'
		}, function(){
			$scope.getInboxCounter();

			for (let i = 0; i < $scope.messages.length; i++) {
				let message = $scope.messages[i];

				if(selectedMessagesIds.indexOf(message.id) > -1){
					$scope.messages[i].labels_assigned.push(label);

					// if($scope.labelsMode === 'move') {
					// 	$scope.messages.splice(i, 1);
					// }
				}
			}

			// let switchToNextMessage = $scope.applyMode === 'next';
			// getEmails(switchToNextMessage);
		});
	};

	$scope.unsetLabels = function(message, label, $labelIndex, $event){
		if($event){
			$event.stopPropagation();
			$event.stopImmediatePropagation();
		}

		let selectedMessagesIds = Object.values($scope.selectedMessages).map(function(i){
			return i.id;
		});

		selectedMessagesIds = selectedMessagesIds || [];
		selectedMessagesIds.push(message.id);

		Emails.unsetLabel({
			emailIds: selectedMessagesIds,
			labelId:  label.id
		}, function(){
			$scope.getInboxCounter();
			message.labels_assigned.splice($labelIndex, 1);

			angular.forEach($scope.selectedMessages, function(i){
				i.labels_assigned = i.labels_assigned.filter(function(ll){
					return ll.id !== label.id
				})
			});
		});
	};

	$scope.openMessage = function(message, $index, $event){
		let shiftIsPressed   = false;
		let controlIsPressed = false;

		if($event){
			shiftIsPressed   = $event.originalEvent && $event.originalEvent.getModifierState('Shift');
			controlIsPressed = $event.originalEvent && $event.originalEvent.getModifierState('Control');
		}

		if(shiftIsPressed && $scope.openedMessage){
			if($event){
				$event.preventDefault();
			}

			let startIndex = Math.min($scope.openedMessageIndex, $index);
			let endIndex   = Math.max($scope.openedMessageIndex, $index);

			for(let currentIndex = startIndex; currentIndex <= endIndex; currentIndex++){
				$scope.selectMessage(currentIndex, $event);
			}
		} else if(controlIsPressed){
			if($event){
				$event.preventDefault();
			}

			$scope.selectMessage($index, $event);
		} else {
			$scope.checkAllActive = true;
			$scope.checkAll();
		}


		Emails.open({id: message.id}, function(data) {
			$scope.openedMessage = data;
			$scope.openedMessageIndex = $index;
			$scope.messages[$index].read = true;
			$scope.messagePreviewHeight = 400; // initial .message-preview height, see right right-bar.scss
			// $scope.mode = $scope.openedMessage.body_html ? 'html' : 'text';
		})
	};

	$scope.openedMessageUrl = function(){
		if(!$scope.openedMessage){
			return '';
		}

		return $sce.trustAsUrl('/inbox/render/' + $scope.openedMessage.id + '?type=' + $scope.mode);
	};

	$scope.openMsCampaigns = function (message, $event) {
		$event.stopPropagation()

		uiSimpleModal({
			title:       'Campaigns',
			templateUrl: '/app/omfm/templates/emailCampaingsModal.html',
			size: '',
			showTitleClose: true,
			data: {
				message: message
			},
			buttons: ['ok', 'cancel']
		})
	}

	$scope.messageDatetime = function(date){
		let now = new Date();
		let dateObj = Utilities.parseDateString(date);
		let dateString = '';

	    if(Utilities.createDate(now, 'm.Y') !== Utilities.createDate(dateObj, 'm.Y')) {
		    // letter if another year
		    dateString = Utilities.createDate(dateObj, 'd M y') + ', ';
	    } else if(Utilities.createDate(now, 'd.m') !== Utilities.createDate(dateObj, 'd.m')) {
	    	// letter in another month
		    dateString = Utilities.createDate(dateObj, 'd M') + ', ';
	    } else {
	    	// letter is today
		    dateString = '';
	    }

		return dateString.toLowerCase() + dateObj.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
	};

	$scope.closeMessage = function(){
		$scope.openedMessage = null;
		$scope.messagePreviewHeight = 0;
		// $scope.mode = null;
	};

	$scope.markAsRead = function(){
		let selectedMessagesIds, read;

		selectedMessagesIds = Object.values($scope.selectedMessages).map(function(i){
			return i.id;
		});
		$scope.readAllActive = !$scope.readAllActive;
		read = $scope.readAllActive;

		Emails.markAsRead({
			emailIds: selectedMessagesIds,
			read: read
		}, function () {
			angular.forEach($scope.selectedMessages, function(i){
				i.read = read;
			});
		})
	};

	$scope.getLabels = function(startInit = true, account_id = 'all'){
		Labels.list({account_id: account_id}, function(result){
			$scope.labels = result;

			let restrictedLabelsAccess = jQuery("#restricted_labels_access").length > 0;

			$scope.labels.unshift(
				{id: 'all', 'label_name': 'All mail'},
				{id: 'inbox', label_name: 'INBOX'},
			);

			if(!restrictedLabelsAccess){
				$scope.labels.unshift(
					{id: 'archived', label_name: 'Archived'},
					{id: 'not_labeled', label_name: 'Not labeled'},
					{id: 'not_labelled_for_report', label_name: 'Not labeled for MS report'},
					{id: 'qual_op', label_name: 'Qual Op (label starts with 1.)'},
					{id: 'potentional_1', label_name: 'Potentional 1 (label starts with 2.)'},
				);
			}


			$timeout(function() {
				jQuery('#labelsList').select2({
					placeholder: "Select label to filter"
				});
			}, 20);

			if(startInit){
				init();
			}

		})
	};

	$scope.getAccounts = function(){
		Accounts.list({}, function(result){
			$scope.accounts = result;
			$timeout(function(){
				jQuery('#accountsFilter').select2({
					placeholder: "Select accounts to filter",
				});
			}, 20);

			$scope.getLabels();
		})
	};

	$scope.setAccountFilter = function(account){
		$location.search('selectedAccounts', angular.toJson($scope.selectedAccounts));

		$scope.filters.account_id = account.id;
		$scope.selectedMessages = {};
		$scope.getInboxCounter();
		$scope.getLabels(false, account.id);
		$scope.pageChanged(true);
	};

	$scope.setAccountUpdateInbox = function(account){
		$scope.updateAccountInboxId = account.id;
	};

	$scope.addAccountToSelected = function(){
		let account = $scope.accounts.filter(function(i){
			return i.id === $scope.filters.account_id;
		})[0];

		if(!account){
			return;
		}

		let accountAdded = $scope.selectedAccounts.filter(function(i){
			return i && i.id === $scope.filters.account_id;
		}).length === 1;

		if(accountAdded){
			return;
		}

		$scope.selectedAccounts.push(account);
		$scope.setAccountFilter(account);

	};

	$scope.switchApplyMode = function(){
		$scope.applyMode = $scope.applyMode === 'next' ? 'current' : 'next'
	};

	$scope.switchLabelsMode = function(){
		$scope.labelsMode = $scope.labelsMode === 'move' ? 'apply' : 'move'
	};

	$scope.removeAccountFromSelected = function ($index) {
		$scope.selectedAccounts.splice($index, 1);
		$location.search('selectedAccounts', angular.toJson($scope.selectedAccounts));
	};

	$scope.deselectLabel = function(label) {
		delete $scope.selectedLabels[label.id];

		if(jQuery.isEmptyObject($scope.selectedLabels)){
			$scope.resetLabels()
		}

		$scope.pageChanged(true);
	};

	$scope.resetLabels = function(){
		$scope.selectedLabels = {'all': {id: 'all', 'label_name': 'All Mail'}};
	};

	$scope.noMessagesSelected = function(){
		if(!$scope.selectedMessages){
			return true;
		}

		return Object.keys($scope.selectedMessages).length === 0;
	};

	$scope.clearSearch = function () {
		$scope.filters.search = '';
		$scope.pageChanged(true);
	};

	$scope.getInboxCounter = function(){
		Emails.inboxCounter({account: $scope.filters.account_id}, function(data){
			if(!data.count){
				return;
			}

			let count = data.count/* - 7700*/;
			count = count > 100 ? '100+' : count;
			let account = $scope.accounts.filter(function(i){
				return i.id == $scope.filters.account_id;
			})[0];

			let accountPrefix = account ? account.name : '';

			window.document.title = `(${count}) ${accountPrefix} ` + $scope.docTitle;
		});
	};

	$scope.$on("angular-resizable.resizeEnd", function (event, args) {
		if(args.height) {
			$scope.messagePreviewHeight = args.height;
		}
	});

	// init. Get Accounts -> Get Labels -> Init filters -> Get emails
	$scope.getAccounts();

	function initLabelFilters() {
		for (let labelId of $scope.filters.label_names) {
			if(!labelId){
				continue
			}


			let label = $scope.labels.filter(function(i){
				return i.label_name == labelId;
			})[0]

			if(!label) {
				continue
			}

			$scope.selectedLabels[labelId] = label
		}
	}

	// function startCheckingForNewEmails() {
	// 	$scope.checkingNewEmails = false;
	//
	// 	$interval(function(){
	//
	// 		if($scope.checkingNewEmails){
	// 			return;
	// 		}
	//
	// 		$scope.checkingNewEmails = true;
	//
	// 		Emails.checkNewEmails({filters: $scope.filters, page: $scope.currentPage}, function(r){
	// 			$scope.checkingNewEmails = false;
	//
	// 			let lastId = r.id;
	//
	// 			if($scope.latestId && lastId > $scope.latestId){
	// 				getEmails();
	// 			}
	// 		})
	// 	}, 10000) // every 10 secs
	// }

	function init(){
		$scope.messagePreviewHeight = 0;
		$scope.selectedAccount = null;
		$scope.searchLabelsToApply = '';
		$scope.labelToFilter = {};
		$scope.selectedLabels = {
			'inbox': {id: 'inbox', 'label_name': 'INBOX'}
		};
		$scope.checkAllActive = false;
		$scope.openedMessageIndex = undefined;
		$scope.readAllActive = false;
		$scope.selectedMessages = {};
		$scope.openedMessage = null;
		$scope.mode = 'text';
		$scope.labelsMode = 'move';
		$scope.applyMode = 'next';
		$scope.labelIdToApply = null;

		$scope.totalItems   = 0;
		$scope.itemsPerPage = 20;

		$scope.currentPage = $location.search().currentPage;
		if(!$scope.currentPage){
			$scope.currentPage  = 1;
		}

		$scope.selectedAccounts = angular.fromJson($location.search().selectedAccounts);

		if(!$scope.selectedAccounts){
			$scope.selectedAccounts  = [];
		}

		$scope.filters = angular.fromJson($location.search().filters);
		if (!$scope.filters) {
			$scope.filters = {
				'account_id': 'all',
				'label_names':  ['inbox'],
				'date_from':  null,
				'date_to':    null,
			};
		}

		initLabelFilters();
		$scope.addAccountToSelected();
		$scope.getInboxCounter();

		$interval(function(){
			$scope.getInboxCounter();
		}, 5 * 60 * 1000); // every 5 minutes

		$scope.pageChanged(true);
		// startCheckingForNewEmails();

		// console.log($scope.labels);
	}

	$scope.docTitle = window.document.title;



	jQuery(document).on('keyup', function(event){
		let keyCode = event.which;
		clickOnRequiredMessage(keyCode);
	});
}
